import superMeta from '../_CATEGORY/metaCategoryNode.mjs'

export default {
    ...superMeta,
    name: '界面原型',
    type: 'UI_DEMO',
}
